import { SetRoutes } from 'components';
import routes from './routes';

const Pages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default Pages;
